
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.5 24.01h-21a1.5 1.5 0 01-1.5-1.5v-21A1.5 1.5 0 011.5.01h21a1.5 1.5 0 011.5 1.5v21a1.5 1.5 0 01-1.5 1.5zm-21-23a.5.5 0 00-.5.5v21a.5.5 0 00.5.5h21a.5.5 0 00.5-.5v-21a.5.5 0 00-.5-.5z"}}),_c('path',{attrs:{"d":"M9.7 17.27a.5.5 0 01-.36-.15l-4.7-4.81a.5.5 0 01.72-.7l4.33 4.45 8.95-9.18a.5.5 0 01.72.7l-9.3 9.54a.5.5 0 01-.37.15z"}})])
          )
        }
      }
    